import { SlotsFilters } from './types';

export const applyQueryFiltersToSlots = (
	inputSlots: any[],
	filters: SlotsFilters
): any[] => {
	let nextSlots: any[] = inputSlots.reduce((acc, slot) => {
		if (filters.codeFilter && slot.code !== filters.codeFilter) return acc;
		if (filters.teacherFilter && slot.defaultTeacher !== filters.teacherFilter) return acc;
		if (filters.dayFilter && slot.day !== filters.dayFilter) return acc;
		if (filters.durationFilter && Number(slot.duration) !== Number(filters.durationFilter)) return acc;
		if (filters.locationFilter && slot.location !== filters.locationFilter) return acc;

		return [...acc, slot];
	}, [] as any[]);

	if (filters.nonEmptyOnly) {
		nextSlots = nextSlots.filter((slot) => slot?.reservations?.length || slot?.lessons?.length);
	}
	if (filters.availableOnly) {
		nextSlots = nextSlots.filter((slot) => {
			return slot && !slot.hidden && !slot.isBlocked;
		});
	}
	if (filters.startedOnly) {
		nextSlots = nextSlots.filter((slot) => slot?.started);
	}

	return nextSlots;
};
